import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { PageContentPreloader, NoItemsPanel, SearchPanel } from 'common/components';
import { PaymentsTable } from 'backoffice/payments/_components';
import noPaymentsImage from 'common/images/noPayments.svg';

import { getCrmFinancesDeposits, getCrmFinancesPaymentSystems } from '../../_redux';

const CRMDepositsTab = ({
  deposits,
  depositsAreLoaded,
  paymentSystems,
  paymentSystemsAreLoaded,
  getCrmFinancesDeposits,
  getCrmFinancesPaymentSystems,
  location,
  history,
  intl,
}) => {
  const parsedSearch = useMemo(() => queryString.parse(location.search), [location.search]);
  const { tab, ...restSearch } = parsedSearch;
  const query = useMemo(() => ({ page_size: 10, ...restSearch }), [location.search]);

  useEffect(() => {
    if (tab !== 'deposits') return;
    getCrmFinancesDeposits({ search: query });
  }, [getCrmFinancesDeposits, location.search]);

  useEffect(() => {
    getCrmFinancesPaymentSystems();
  }, [getCrmFinancesPaymentSystems]);

  const optionsPaymentSystemList = [];
  if (paymentSystemsAreLoaded) {
    paymentSystems.map(ps =>
      optionsPaymentSystemList.push({ value: ps.paymentSystemSlug, label: ps.paymentSystemSlug })
    );
  }

  const filters = [
    {
      title: 'justStatus',
      accessor: '_status',
      options: [
        { value: '', label: intl.formatMessage({ id: 'justAll' }) },
        { value: 'money_waiting', label: intl.formatMessage({ id: 'status_money_waiting' }) },
        { value: 'in_process', label: intl.formatMessage({ id: 'status_in_process' }) },
        { value: 'canceled', label: intl.formatMessage({ id: 'status_canceled' }) },
        { value: 'failed', label: intl.formatMessage({ id: 'status_failed' }) },
        { value: 'received', label: intl.formatMessage({ id: 'status_received' }) },
        { value: 'deposited', label: intl.formatMessage({ id: 'status_deposited' }) },
      ],
    },
    {
      title: 'paymentSystem',
      accessor: 'payment_system_slug',
      options: [{ value: '', label: intl.formatMessage({ id: 'justAll' }) }, ...optionsPaymentSystemList],
    },
  ];

  return (
    <div className="FinancesPage__deposits-tab">
      <PageContentPreloader ready={depositsAreLoaded} type="smallLines" firstLaunchOnly>
        <SearchPanel
          location={location}
          history={history}
          getList={data => getCrmFinancesDeposits({ search: data.search })}
          filters={filters}
          params={{ search: query }}
        />
        {deposits.count ? (
          <PaymentsTable
            data={deposits}
            exportButtonCaptionSlug=""
            type="deposits"
            loading={!depositsAreLoaded}
            location={location}
            history={history}
            getList={data => getCrmFinancesDeposits({ search: data.search })}
            onRowClick={() => {}}
            params={{ search: query }}
            allowManagePaymentsExports={false}
            hasPaymentOperationManagers={false}
            disableLinks
            hideColumns={['boAmount', 'justRequestedCommission', 'boPaymentMethod', 'justPaymentTags']}
            hideMetadataFilter
            noResponsive
          />
        ) : (
          <NoItemsPanel
            icon={noPaymentsImage}
            captionSlug={Object.keys(query).length ? 'noDepositsMatchingTheParameters' : 'noPaymentsDeposit'}
          />
        )}
      </PageContentPreloader>
    </div>
  );
};

CRMDepositsTab.propTypes = {
  deposits: PropTypes.object.isRequired,
  depositsAreLoaded: PropTypes.bool.isRequired,
  paymentSystems: PropTypes.array.isRequired,
  paymentSystemsAreLoaded: PropTypes.bool.isRequired,
  getCrmFinancesDeposits: PropTypes.func.isRequired,
  getCrmFinancesPaymentSystems: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default compose(
  injectIntl,
  withRouter,
  connect(
    state => ({
      deposits: state.crm.finances.deposits,
      depositsAreLoaded: state.crm.finances.depositsAreLoaded,
      paymentSystems: state.crm.finances.paymentSystems,
      paymentSystemsAreLoaded: state.crm.finances.paymentSystemsAreLoaded,
    }),
    {
      getCrmFinancesDeposits: search => getCrmFinancesDeposits.request(search),
      getCrmFinancesPaymentSystems: () => getCrmFinancesPaymentSystems.request(),
    }
  )
)(CRMDepositsTab);
